import { PostSection } from "@/components/blog/PostSection";
import { PostQuote } from "@/components/blog/PostQuote";

export function ContenidoSemanticoSection() {
  return (
    <PostSection id="contenido-semantico" title="Contenido semántico y listo para IA">
      <p>
        Los motores de IA no buscan repeticiones de keywords, sino <strong>significado, contexto, 
        calidad y contenido útil</strong>. Textos largos y superficiales pierden relevancia. 
        Lo que importa es ofrecer respuestas completas y bien estructuradas.
      </p>

      <h3 id="estructura-citacion" className="text-xl font-bold text-white mt-8 mb-4">
        Estructura optimizada para citación
      </h3>
      <PostQuote 
        text="Si tu artículo podría estar firmado por un competidor y nadie notaría la diferencia, no es un activo."
        author="Principio de contenido diferencial 2026"
      />
      <p className="mt-4">
        Formatos que mejor funcionan en 2026:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-4">
        <li><strong>Checklists:</strong> «antes de…» / «revisa esto» — contenido accionable</li>
        <li><strong>Errores comunes:</strong> los que ves en proyectos reales, con soluciones concretas</li>
        <li><strong>Guías de decisión:</strong> «si tu caso es A, prioriza B» — ayuda a decidir</li>
        <li><strong>Comparativas reales:</strong> con pros y contras verificados</li>
        <li><strong>Pasos ordenados:</strong> no teoría, acción concreta</li>
      </ul>
      <p className="mt-4">
        La estructura que más retiene y más cita Google:
      </p>
      <ol className="list-decimal pl-6 space-y-2 mt-4">
        <li>Empieza con una <strong>respuesta corta y clara</strong> (50-80 palabras)</li>
        <li>Explica el <strong>por qué</strong> (lo que diferencia)</li>
        <li>Da <strong>pasos y ejemplos</strong> (lo que el lector agradece)</li>
        <li>Termina con un <strong>mini resumen o checklist</strong></li>
      </ol>

      <h3 id="contenido-multimodal" className="text-xl font-bold text-white mt-8 mb-4">
        Contenido multimodal: texto, vídeo y audio
      </h3>
      <p>
        Ya no basta con un buen texto. Si quieres visibilidad máxima en 2026, tu estrategia debe 
        incluir <strong>imágenes, infografías, vídeos y podcasts</strong>. Los motores de IA integran 
        cada vez mejor estos formatos y pueden extraer información, resumirla o referenciarla.
      </p>
      <p className="mt-4">
        Esto amplía tus posibilidades de aparecer tanto en resultados tradicionales como en respuestas 
        generadas por IA, resultados de búsquedas visuales o de voz, e incluso en entornos de dispositivos 
        móviles y asistentes inteligentes.
      </p>
    </PostSection>
  );
}
